import axiosInstance from '../functions/axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];
const getTrackedChanges = async (resourceId, apiToken = null) => {
    console.log("CALLING SERVER with gettrackedchanges")
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'gettrackedchanges',
            'foi': resourceId,
            'apiToken': apiToken
        },
    }).then((resp) => {
        if (resp?.data) {
            //resp.data is { 'success': true, 'changes': {} } 
            if (resp.data?.success && resp.data.changes) {
                return resp.data.changes;
            } else {
                console.log("FAILED RESPONSE from gettrackedchanges call")
                return { } ;
            }
        }
        console.log("NO RESPONSE from gettrackedchanges call");
    }).catch((error) => { console.log(error); });
};

export default getTrackedChanges;